angular.module('angus.filters').filter('toSelect2List', function() {
    return function(listToSelectFrom, propertyNameForID, value) {
        var out = _(listToSelectFrom).filter(function(listItem) {
            return listItem[propertyName] == value;
        });

        return out.value();
    };
});
